// This module MUST be imported first to set up globals before Bootstrap loads
import jQuery from 'jquery';
import moment from 'moment';

// Set globals immediately
window.$ = window.jQuery = jQuery;
window.moment = moment;

console.log('Globals initialized: jQuery version', jQuery.fn.jquery);
